import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import React from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../Lib/Object/deepEquals';
import { IWithWorksheetInjectedProps } from '../types';
import AutoImportWorksheetTestResultsDestinations from './AutoImportWorksheetTestResultsDestinations';
import OtherImportWorksheetTestResultsDestinations from './OtherImportWorksheetTestResultsDestinations';

import { AssociatedTestType } from './types';

let WorksheetTestResultsDestinations: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const destinations = useSelector(createWorksheetSelector!('header.TestResultsDestinations', false), deepEquals);
  const readClaims = useSelector((s) => s.user.data.Claims['sq.worksheets.read']);

  if (!destinations || destinations.length === 0) return null;
  const readableWorksheets = readClaims ? readClaims.split(',') : [];
  const autoImportedTests = destinations.filter(
    (destination: any) => destination.AssociatedTestType === AssociatedTestType.AutoImported
  );
  const otherImportedTests = destinations.filter(
    (destination: any) => destination.AssociatedTestType !== AssociatedTestType.AutoImported
  );
  return (
    <>
      {autoImportedTests.length > 0 && (
        <AutoImportWorksheetTestResultsDestinations
          readableWorksheets={readableWorksheets}
          imports={autoImportedTests}
        />
      )}
      {otherImportedTests.length > 0 && (
        <OtherImportWorksheetTestResultsDestinations
          readableWorksheets={readableWorksheets}
          imports={otherImportedTests}
        />
      )}
    </>
  );
};

WorksheetTestResultsDestinations = withInjectedProps(WorksheetTestResultsDestinations);

export { WorksheetTestResultsDestinations };
export default WorksheetTestResultsDestinations;
